(ns quuppa.qsm.register-qpe.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
  :qpe/preconfigured-qpes
  (fn [db [_]]
    (get db :preconfigured-qpes)))

(rf/reg-sub
  :qpe-register/form
  (fn [db [_]]
    (get-in db [:register-qpe-form])))
